export enum ExactBatchExportStatus {
    complete = 'complete',
    completeWithErrorsOrWarnings = 'completeWithErrorsOrWarnings',
    uncomplete = 'uncomplete',
}
